import styled, { css } from "styled-components"
import Breakpoints from "../shared/breakpoints"
import Typography from "../shared/typography.styles"

export const HeroOverlay = css`
  background-color: #7e2d16;
  mix-blend-mode: multiply;
`

export const HeroContent = styled.div`
  padding: 114px 0 133px 0;
  grid-column: 2 / -2;
  display: flex;
  flex-direction: column;
  color: var(--white);

  @media (min-width: ${Breakpoints.md}) {
    grid-column: 2 / -3;
  }
  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 2 / 7;
    padding: 216px 0 148px 0;
  }
`

export const Title = styled.h1`
  ${Typography.mobileTextStyles.MobileHeadingOneSemiBold}
  
  @media (min-width: ${Breakpoints.md}) {
    ${Typography.tabletTextStyles.TabletHeadingOneRegular}
    white-space: nowrap;
  }
  @media (min-width: ${Breakpoints.lg}) {
    ${Typography.desktopTextStyles.HeadingOneRegular}
  }
`

export const HeroTextContainer = styled.figure`
  margin-top: 32px;
`

export const HeroText = styled.p`
  ${Typography.mobileTextStyles.MobileBodyRegular}
  @media (min-width: ${Breakpoints.md}) {
    
  }
  @media (min-width: ${Breakpoints.lg}) {
    ${Typography.desktopTextStyles.BodyText18}
  }
`

export const QuoteAttribution = styled.figcaption`
  ${Typography.mobileTextStyles.MobileHeadingFourRegular}
  color: var(--white);
  display: flex;
  align-items: center;
  margin-top: 24px;

  ::before {
    display: inline-block;
    content: " ";
    width: 16px;
    height: 1px;
    margin-right: 16px;
    border-bottom: 1px solid #fff;
    align-self: flex-start;
    padding-top: 10px;
  }

  @media (min-width: ${Breakpoints.md}) {
    ::before {
      width: 24px;
      margin-right: 24px;
      align-self: center;
      padding-top: 0px;
    }
    & > br {
      display: none;
    }
  }
  @media (min-width: ${Breakpoints.lg}) {
    margin-top: 32px;
    ${Typography.desktopTextStyles.HeadingSixRegular}
  }
`
